import React from 'react';
import PropTypes from "prop-types";
import classnames from 'classnames';
import './FundkyCollapse.less';

class FundkyCollapse extends React.Component {
  render() {
    const { className, isOpened, transitionTime } = this.props;
    const classes = classnames('FundkyCollapse', className, {visible: isOpened});
    const transitionStyle = transitionTime ? {
      transition: `all ${transitionTime} ease-in-out`
    } : null;

    return (
      <div style={transitionStyle} className={classes}>
        {this.props.children}
      </div>
    );
  }
}

FundkyCollapse.defaultProps = {
  isOpened: false,
  transitionTime: ''
};

FundkyCollapse.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  isOpened: PropTypes.bool.isRequired,
  transitionTime: PropTypes.string
};

export default FundkyCollapse;
